import script from "./CreatorMemberJoinedCongratsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CreatorMemberJoinedCongratsModal.vue?vue&type=script&setup=true&lang=js"

import "./CreatorMemberJoinedCongratsModal.vue?vue&type=style&index=0&id=2a998000&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a998000"]])

export default __exports__